// import $ from 'jquery';
import _ from 'lodash'
import { createAlert, scrollTo } from '../dom/window'
import {
  buildSupplierCartList,
  buildSupplierCartItem,
  appendCartListWithBackOrder,
  getDumbCartForMember,
  getProductsFullInfo,
} from '../selectors/converterSelectors'
import {
  addRemoteCartItems,
  addRemoteCartItemsCaseAndUnit,
  requestFromServer,
  updateCartList,
} from './cartSupplierActions'
import config from '../store/_config'
import {
  axiosInstance as axios,
  handleAxiosErrors,
  floorToTwoDecimals,
  breakListIntoChunks,
  storageAvailable,
  createAxiosCancellationToken,
} from '_utils'
import {
  convertFrontlineProductsPricesToAReadableFormat,
  convertProductsListingToAReadableFormat,
  convertProductsPricesToAReadableFormat,
} from '../selectors/productSelectors'
import { axiosRequestFrontlineProductsPrices } from './productMaintenanceActions'
import { buildRequestProductListParams, getStartingIndex } from '../../main/selectors/defaultSelectors'
import { getFilterValues } from './productsPerPageActions'
import { LS } from '../store/localStorage'
import $ from '../../../_lib/jquery-3.2.1.min'
import {
  axiosRequestProcessedProductsPrices,
  axiosRequestEnCustomerDiscounts,
  axiosRefreshEnCustomerDiscounts,
} from './productsActions'
import { updateAvailableProducts } from './dealBuilderActions'
import { setUserCredentials, setDiscountSyncing } from './userActions'

let cancelToken = {}

export const toggleLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCT_LIST_SUPPLIER_LOADING',
      value: value,
    })
  }
}

/**
 * Toggle Loading
 *
 * @param key
 * @param value
 * @returns {{type: string, value: *, key: *}}
 */
export const toggleDealBuilderLoading = (key, value) => {
  return {
    type: 'TOGGLE_DEAL_BUILDER_LOADING',
    key: key,
    value: value,
  }
}

export const changePagination = (page) => {
  return (dispatch, getState) => {
    dispatch(changeActivePage(page + 1))
    scrollTo($('#place-order-list'), 10)
  }
}
export const changeSearch = (params) => {
  return (dispatch, getState) => {
    Promise.all([dispatch(updateSearchQuery(params.search))]).then(() => {
      dispatch(changeActivePage(1))
    })
  }
}
export const updateSearchQuery = (keyword) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PRODUCTS_SUPPLIER_SEARCH',
      value: keyword,
    })
  }
}

export const updateSoldToThreePLOnly = (keyword) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_SOLD_TO_THREE_PL_ONLY',
      value: keyword,
    })
  }
}

export const updateSoldAtLocation = (keyword) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_SOLD_AT_LOCATION',
      value: keyword,
    })
  }
}

export const updateWithSuperSupplierBrands = (keyword) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_WITH_SUPER_SUPPLIER_BRANDS',
      value: keyword,
    })
  }
}

export const updateWithDummyProducts = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_WITH_DUMMY_PRODUCTS',
      value: value,
    })
  }
}

export const updateAsnList = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_ADVANCE_SHIPPING_LIST',
      value: value,
    })
  }
}

export const toggleAnsListLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_ANS_LIST_LOADING',
      value: value,
    })
  }
}

// asn list
export const requestAsnList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    let { url, query } = config.advancedShippingNotice.readAdvancedShippingNotice
    const { user } = state.user
    dispatch(updateAsnList([]))
    dispatch(toggleAnsListLoading(true))
    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query: query,
          variables: {
            Status: params?.Status ? params?.Status : '',
          },
        },
      })
      .then((response) => {
        if (response?.data?.data?.readAdvancedShippingNotice?.length > 0) {
          dispatch(updateAsnList(response?.data?.data?.readAdvancedShippingNotice))
        }
        dispatch(toggleAnsListLoading(false))
      })
      .catch((error) => {
        dispatch(toggleAnsListLoading(false))
        handleAxiosErrors(error)
      })
  }
}

// asn products list
export const requestAsnProductsList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(toggleLoading(true))

    return axiosRequestProductList(state, params)
      .then((response) => {
        if (typeof response?.data?.data?.searchResult != 'undefined') {
          const products = convertProductsListingToAReadableFormat(
            response?.data?.data?.searchResult?.edges,
            state.user
          )
          const totalProducts = response?.data?.data?.searchResult?.pageInfo?.totalCount
          if (products?.length == 0) {
            dispatch(toggleLoading(false))
            dispatch(updateFullProductsList(products))
            dispatch(updateProductsList(products, totalProducts))
          }
          // wait for async requests
          Promise.all([
            dispatch(updateFullProductsList(products)),
            dispatch(updateProductsList(products, totalProducts)),
          ]).then(() => {
            dispatch(toggleLoading(false))
            dispatch(
              setUserCredentials({
                customerPromo: {},
              })
            )
          })
        } else {
          dispatch(toggleLoading(false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading(false))
        return handleAxiosErrors(error)
      })
  }
}

// products
export const requestProductsList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    console.log('params in requestProductsList 22222', { params })
    dispatch(toggleLoading(true))
    dispatch(setDiscountSyncing(true))

    // Removing current customer location from storage to handle request product list call when location is changed on 3pl customer select
    localStorage.setItem('currentCustomerLocation', '')

    return axiosRequestProductList(state, params)
      .then((response) => {
        if (typeof response?.data?.data?.searchResult != 'undefined') {
          const products = convertProductsListingToAReadableFormat(
            response?.data?.data?.searchResult?.edges,
            state.user
          )
          const totalProducts = response?.data?.data?.searchResult?.pageInfo?.totalCount
          if (products?.length == 0) {
            dispatch(toggleLoading(false))
            dispatch(updateFullProductsList(products))
            dispatch(updateProductsList(products, totalProducts))
            dispatch(setDiscountSyncing(false))
          }
          // const products = convertProductsListingToAReadableFormat(response.data.hits.hits, state.supplier.activeCustomer); // not using this because supplier always load using user data
          // const categories = convertProductListingCategories(response.data.hits.hits, state.user); // NOTE: this was removed from the query on 18/12

          // Get product IDs to request price
          const productIDs = products.map((item) => item.productID)

          // wait for async requests
          Promise.all([
            dispatch(updateFullProductsList(products)),
            dispatch(updateProductsList(products, totalProducts)),
          ])
            .then(() => {
              dispatch(
                setUserCredentials({
                  customerPromo: {},
                })
              )
            })
            .then(async () => {
              // if(currentStartingIndex == 0) {
              //     dispatch(toggleLoading(false));
              // }
              //
              // if(totalRecords > totalRequestedRecords) {
              //     dispatch(requestProductsList({startingIndex: totalRequestedRecords - 1, amount: 200}));
              // }
              //
              await dispatch(requestDiscountedProductsPrices(productIDs, products))
            })
        } else {
          dispatch(toggleLoading(false))

          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading(false))
        return handleAxiosErrors(error)
      })
    // .then(() => {
    //   dispatch(toggleLoading(false))
    // })
  }
}
export const axiosRequestProductList = (state, params) => {
  const {
    filters,
    perPage,
    searchKeyword,
    sortBy,
    sortDirection,
    SoldToThreePLOnly,
    FilterSoldAtLocation,
    WithSuperSupplierBrands,
    WithDummyProducts,
  } = state.productsSupplier
  const { ContainerType, Brand, Region, Country, Style, Type, Varietal } = filters
  const { startingIndex } = params

  let { url, query } = config.products.listingSupplier
  let q = searchKeyword || window.searchKeyword

  query = query.replace(
    /{params}/,
    buildRequestProductListParams({
      q,
      CategoryURL: window.categoryURL,
      limit: params?.perPage || perPage,
      offset: startingIndex || 0,
      ContainerType: getFilterValues(ContainerType),
      Varietal: getFilterValues(Varietal),
      LiquorStyle: getFilterValues(Style),
      Country: getFilterValues(Country),
      Region: getFilterValues(Region),
      Brand: getFilterValues(Brand),
      DisplayPrice__gte: 0,
      DisplayPrice__lte: 10000,
      WithSuperSupplierBrands: WithSuperSupplierBrands || false,
      SoldToThreePLOnly: SoldToThreePLOnly || false,
      FilterSoldAtLocation: FilterSoldAtLocation || false,
      WithDummyProducts: WithDummyProducts || false,
    })
  )

  if (cancelToken.searchResult) {
    cancelToken.searchResult.cancel()
  }

  cancelToken.searchResult = createAxiosCancellationToken()

  return axios.get(url, {
    params: {
      query: query,
    },
    cancelToken: cancelToken.searchResult.token,
  })
}
export const requestProductsPrices = (list) => {
  return (dispatch, getState) => {
    // Break the request into every 700
    const chunkedList = breakListIntoChunks(list, 700)

    chunkedList.map((chunkedProductIDs) => {
      const state = getState()

      axiosRequestFrontlineProductsPrices(state, chunkedProductIDs)
        .then((response) => {
          const { data } = response
          const products = convertFrontlineProductsPricesToAReadableFormat(
            data,
            state.user,
            state.productsSupplier.list
          )
          dispatch(updateProductsList(products))
        })
        .catch((error) => handleAxiosErrors(error))
    })
  }
}

const pollingSupplierDiscountSyncing = (list, products, memberID, zoneID = 0) => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(setDiscountSyncing(true))
    if (window.pollingAxios) {
      clearInterval(window.pollingAxios)
    }

    async function pollingAxios() {
      try {
        const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(state, memberID)
        const discountSyncing = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts
          ?.IsDiscountSyncing

        if (discountSyncing === false) {
          clearInterval(window.pollingAxios)

          // dispatch(setDiscountSyncing(false))
          await dispatch(requestDiscountedProductsPrices(list, products, memberID, zoneID))
        }
      } catch (error) {
        console.log('polling discount syncing error')
        handleAxiosErrors(error)
      }
    }

    window.pollingAxios = setInterval(pollingAxios, 3000, state)
  }
}

export const getSupplierCustomerPromo = (productIDs, products, memberID, zoneID = 0) => {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(setDiscountSyncing(true))
    let customerPromo = {}
    try {
      const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(state, memberID)
      customerPromo = JSON.parse(enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.Discounts)
      const discountSyncing = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.IsDiscountSyncing
      if (discountSyncing === true) {
        dispatch(setDiscountSyncing(true))
        dispatch(pollingSupplierDiscountSyncing(productIDs, products, memberID, zoneID))
        return {}
      } else {
        return customerPromo
      }
    } catch (error) {
      handleAxiosErrors(error)
      return
    }
  }
}

export const requestDiscountedProductsPrices = (list, products, memberID, zoneID = 0, activeSurcharge = true) => {
  return async (dispatch, getState) => {
    const store = getState()
    console.log('memberID=====', memberID)
    const chargeAreaID = activeSurcharge && store?.user?.chargeArea ? store?.user?.chargeArea : 0
    await axiosRefreshEnCustomerDiscounts(memberID)
    const enCustomerDiscountsDataResponse = await axiosRequestEnCustomerDiscounts(store, memberID)
    const discountSyncing = !!enCustomerDiscountsDataResponse?.data?.data?.readEnCustomerDiscounts?.IsDiscountSyncing
    const customerPromo = await dispatch(getSupplierCustomerPromo(list, products, memberID, zoneID))

    if (!discountSyncing) {
      // Break the request into every 700
      const chunkedList = breakListIntoChunks(list, 700)
      chunkedList.map(async (chunkedProductIDs) => {
        if (chunkedProductIDs && chunkedProductIDs.length > 0) {
          await axiosRequestProcessedProductsPrices(chunkedProductIDs, memberID, zoneID)
            .then((response) => {
              const productPrices = convertProductsPricesToAReadableFormat(response.data.data.readProductPrices, false)

              const mergedProducts = _.map(products, function (item) {
                return _.merge(item, _.find(productPrices, { id: item.id }))
              })

              let _products = []
              mergedProducts.forEach((p) => {
                const {
                  id,
                  sku,
                  wetTax,
                  unit_price,
                  case_price,
                  qty_per_case,
                  wholesale_unit_per_case,
                  splitCaseSurchargesJSON,
                } = p
                let surcharge = splitCaseSurchargesJSON[chargeAreaID] || {}
                let promoListSize = 0
                if (customerPromo) {
                  promoListSize = Array.isArray(customerPromo)
                    ? customerPromo?.length
                    : Object.keys(customerPromo)?.length
                }
                // const target = customerPromo[sku]

                if (promoListSize > 0 && customerPromo && customerPromo[sku]) {
                  _products.push({
                    BuyableID: id,
                    CasePrice: case_price ? case_price * (1 + wetTax) : 0, // ORIGINAL CASE PRICE
                    UnitPrice: unit_price ? unit_price * (1 + wetTax) : 0, // ORIGINAL UNIT PRICE
                    Discount: customerPromo[sku]['CalculatedDiscount1'] || 0, // CASE DISCOUNT
                    UnitDiscount: customerPromo[sku]['CalculatedUnitDiscount2'] * (1 + wetTax) || 0, // UNIT DISCOUNT
                    DiscountedUnitPrice: unit_price
                      ? ((case_price - customerPromo[sku]['CalculatedCaseDiscount2']) / wholesale_unit_per_case) *
                        (1 + wetTax)
                      : 0, // DISCOUNTED UNIT PRICE
                    DiscountedCasePrice: case_price
                      ? (case_price - customerPromo[sku]['CalculatedCaseDiscount2']) * (1 + wetTax)
                      : 0, // DISCOUNTED CASE PRICE
                    QtyPerCase: qty_per_case,
                    WholesaleUnitsPerCase: wholesale_unit_per_case,
                    WetTax: wetTax,
                    FrontLineCasePrice: case_price ? case_price : 0,
                    unitSurcharge: surcharge?.Rate,
                  })
                } else {
                  _products.push({
                    BuyableID: id,
                    CasePrice: case_price ? case_price * (1 + wetTax) : 0,
                    UnitPrice: unit_price ? unit_price * (1 + wetTax) : 0,
                    Discount: 0,
                    UnitDiscount: 0,
                    DiscountedUnitPrice: unit_price ? (unit_price / wholesale_unit_per_case) * (1 + wetTax) : 0,
                    DiscountedCasePrice: case_price ? case_price * (1 + wetTax) : 0,
                    QtyPerCase: qty_per_case,
                    WholesaleUnitsPerCase: wholesale_unit_per_case,
                    WetTax: wetTax,
                    FrontLineCasePrice: case_price ? case_price : 0,
                    unitSurcharge: surcharge?.Rate,
                  })
                }
              })

              console.log('ProductsData1', _products)

              const _redo = convertSupplierProductsPricesToAReadableFormat(_products, false)

              console.log('ProductsData2', _redo)

              // Update prices
              dispatch(toggleLoading(false))
              dispatch(updateFullProductsList(_redo))
              dispatch(updateAvailableProducts(_redo))
              dispatch(toggleDealBuilderLoading('products', false))
              dispatch(setDiscountSyncing(false))
            })
            .catch((error) => {
              handleAxiosErrors(error)
              dispatch(toggleLoading(false))
              dispatch(toggleDealBuilderLoading('products', false))
              dispatch(setDiscountSyncing(false))
            })
        }
      })
    }
  }
}

function convertSupplierProductsPricesToAReadableFormat(data, ignoreDiscount = false, isSaleQuote = false) {
  if (!data || data.length === 0) {
    return []
  }

  return data.map((discountData) => {
    let {
      Discount,
      BuyableID,
      UnitPrice,
      CasePrice,
      DiscountedCasePrice,
      DiscountedUnitPrice,
      UnitDiscount = 0,
      QtyPerCase = 1,
      WholesaleUnitsPerCase = 1,
      SupplierDiscountPerCase = 0,
      ParamountDiscount = 0,
      WetTax = 0,
      FrontLineCasePrice = 0,
      Featured = 0,
      unitSurcharge = 0,
    } = discountData

    CasePrice = floorToTwoDecimals(CasePrice)
    UnitPrice = floorToTwoDecimals(UnitPrice)
    DiscountedCasePrice = floorToTwoDecimals(DiscountedCasePrice)
    DiscountedUnitPrice = floorToTwoDecimals(DiscountedUnitPrice)

    if (ignoreDiscount === true) {
      return {
        id: String(BuyableID),
        case_discount: 0,
        case_price: floorToTwoDecimals(CasePrice),
        case_price_tax: 0,
        unit_discount: 0,
        unit_price: floorToTwoDecimals(UnitPrice),
        unit_price_tax: 0,
        hasDiscount: false,
      }
    } else {
      /* Calculate Surcharge on unit price (Ex Wet)*/
      let wetExclCasePrice = DiscountedCasePrice / (1 + WetTax)
      let wetInclUnitPrice = (wetExclCasePrice / WholesaleUnitsPerCase) * (1 + unitSurcharge) * (1 + WetTax)

      const caseDiscount = Discount

      const unitDiscount = UnitDiscount || 0
      const hasDiscount = caseDiscount > 0 || unitDiscount > 0

      let unit_price = UnitPrice
      if (DiscountedUnitPrice) {
        unit_price = floorToTwoDecimals((DiscountedCasePrice - caseDiscount * (1 + WetTax)) / WholesaleUnitsPerCase)
      }

      // const discounted_case_price = DiscountedCasePrice - caseDiscount * (1 + WetTax)
      // const cal_case_price = CasePrice - caseDiscount * (1 + WetTax)
      const discounted_case_price = DiscountedCasePrice - caseDiscount * (1 + WetTax) * (1 + 0)
      const discounted_unit_price = (discounted_case_price / WholesaleUnitsPerCase) * (1 + unitSurcharge)

      const cal_case_price = CasePrice - caseDiscount * (1 + 0)
      const cal_unit_price = (cal_case_price / WholesaleUnitsPerCase) * (1 + unitSurcharge)

      return {
        id: String(BuyableID),
        case_discount: floorToTwoDecimals(caseDiscount),
        supplier_discount_per_case: parseFloat(SupplierDiscountPerCase).toFixed(2),
        paramount_discount: parseFloat(ParamountDiscount).toFixed(2),
        // wet_tax: 0, // floorToTwoDecimals(0),
        wet_tax: isSaleQuote && WetTax ? parseFloat(WetTax) : 0,
        case_price: floorToTwoDecimals(DiscountedCasePrice),
        case_price_tax: 0,
        unit_discount: unitDiscount,
        unit_price: floorToTwoDecimals(wetInclUnitPrice),
        unit_price_tax: 0,
        hasDiscount: hasDiscount,
        hasFeaturedDiscount: hasDiscount && Featured,
        discounted_case_price: floorToTwoDecimals(discounted_case_price),
        discounted_unit_price: floorToTwoDecimals(discounted_unit_price),
        frontline_case_price: floorToTwoDecimals(FrontLineCasePrice),
        cal_case_price: floorToTwoDecimals(cal_case_price),
        cal_unit_price: floorToTwoDecimals(cal_unit_price),
        unitSurcharge: unitSurcharge,
      }
    }
  })

  return newList
}
export const updateProductsList = (productsList, totalProducts) => {
  return (dispatch, getState) => {
    const state = getState()
    const { perPage } = state.productsSupplier

    const newList = productsList.map((item, index) => {
      return item.id
    })

    dispatch(setProductsList(newList))
    dispatch(setTotalPages(Math.ceil(totalProducts / perPage)))
  }
}
export const setPerPage = (perPage) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SUPPLIER_PER_PAGE',
      value: perPage,
    })
  }
}
export const setActivePage = (page) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SUPPLIER_ACTIVE_PAGE',
      value: page,
    })
  }
}
export const setTotalPages = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SUPPLIER_TOTAL_PAGES',
      value: value,
    })
  }
}
export const setSortBy = (sortBy, sortDirection) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SUPPLIER_SORT_BY',
      sortBy: sortBy,
      sortDirection: sortDirection,
    })

    dispatch(requestProductsList({ startingIndex: 0 }))
  }
}
export const setProductsList = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SUPPLIER_DISPLAYED_LIST',
      list: list,
    })
  }
}
export const onFetchData = (tableState, tableInstance) => {
  return (dispatch, getState) => {
    const { sortBy, sortDirection } = getState().productsSupplier
    const { sorted } = tableState

    if (sorted.length) {
      let newSortBy = sorted[0].id
      const newSortDirection = sorted[0].desc ? 'DESC' : 'ASC'

      // update the value
      if (newSortBy == 'title') {
        newSortBy = 'SortableTitle'
      }

      if (sortBy != newSortBy || sortDirection != newSortDirection) {
        dispatch(setSortBy(newSortBy, newSortDirection))
      }
    }
  }
}
export const changeActivePage = (page) => {
  return (dispatch, getState) => {
    dispatch(setActivePage(page))
    dispatch(refreshCurrentView())
  }
}

// asn per page product
export const changeAsnPagination = (page) => {
  return (dispatch, getState) => {
    dispatch(changeAsnActivePage(page + 1))
    // scrollTo($('#place-order-list'), 10)
  }
}

export const changeAsnActivePage = (page) => {
  return (dispatch, getState) => {
    dispatch(setActivePage(page))
    dispatch(refreshCurrentAsnView())
  }
}

export const changeAsnPerPage = (amount) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage')) {
      LS.set('perPage', amount)
    }

    dispatch(setPerPage(amount))
    dispatch(refreshCurrentAsnView())
  }
}

export const refreshCurrentAsnView = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { activePage, perPage } = state.productsSupplier

    dispatch(
      requestAsnProductsList({
        startingIndex: getStartingIndex(perPage, activePage),
      })
    )
  }
}

export const changePerPage = (amount) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage')) {
      LS.set('perPage', amount)
    }

    dispatch(setPerPage(amount))
    dispatch(refreshCurrentView())
  }
}
export const refreshCurrentView = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { activePage, perPage } = state.productsSupplier

    dispatch(
      requestProductsList({
        startingIndex: getStartingIndex(perPage, activePage),
      })
    )
  }
}
export const updateFullProductsList = (list) => {
  return {
    type: 'UPDATE_PRODUCTS_LIST_SUPPLIER',
    list: _.keyBy(list, 'id'),
  }
}
export const updateUserInput = (row, key, value) => {
  return (dispatch, getState) => {
    /*
      Convert units to cases if units entered are equal to a case to manage subcharges 
    */
    let isUnitConverted = false
    let calculatedCases = 1
    if (key == 'unitTotal' && !row?.sell_by_case && row?.qty_per_case && value / row?.qty_per_case >= 1) {
      let newValue = value % row?.qty_per_case
      calculatedCases = (value - newValue) / row?.qty_per_case || 1
      value = newValue
      isUnitConverted = true
    }

    dispatch({
      type: 'UPDATE_PRODUCT_SUPPLIER_USER_INPUT',
      row: row,
      key: key,
      value: value,
    })

    /*
      Update cases qty in cart after converting units to cases
    */
    if (key == 'unitTotal' && isUnitConverted) {
      dispatch(updateUserInput(row, 'caseTotal', parseInt(row?.caseTotal || 0) + parseInt(calculatedCases || 0)))
    }
  }
}
export const clearUserInput = (id) => {
  return {
    type: 'CLEAR_PRODUCT_SUPPLIER_USER_INPUT',
    id: id,
  }
}
export const clearAllUserInput = () => {
  return {
    type: 'CLEAR_ALL_PRODUCT_SUPPLIER_USER_INPUT',
  }
}
export const updateCaseDiscount = (originalData, key, value, previousValue) => {
  const modifiedData = calculateModifiedPriceData(originalData, key, value, previousValue)
  if (!modifiedData) {
    return
  }

  return {
    type: 'UPDATE_PRODUCT_SUPPLIER_CASE_DISCOUNT',
    row: originalData,
    value: modifiedData,
  }
}
export const batchUpdateCaseDiscount = (value) => {
  return {
    type: 'BATCH_UPDATE_PRODUCT_SUPPLIER_USER_INPUT',
    value: value,
  }
}
export const calculateModifiedPriceData = (originalData, key, value, previousValue) => {
  if (value === previousValue) {
    return null
  }
  /**
   * lastKey                      the key that was last updated (percentage, flat, case price)
   *      flat_discount
   *      percentage_discount
   *      case_price
   * lastValue                    the value that was last entered
   * flatDiscountValue            calculated value for flat discount
   * percentageDiscountValue      calculated value for percentage discount
   * casePriceValue               calculated value for case price
   * unitSurcharge                surcharge percentage for unit price (Ex Wet)
   */
  const {
    id,
    sell_by_case,
    qty_per_case,
    case_price,
    unit_price,
    case_discount,
    casePriceValue,
    percentageDiscountValue,
    flatDiscountValue,
    wetTax,
    frontline_case_price,
    wholesale_unit_per_case,
    unitSurcharge = 0,
  } = originalData
  const originalCasePrice = typeof case_price == 'string' ? parseFloat(case_price) : case_price
  const originalUnitPrice = typeof unit_price == 'string' ? parseFloat(unit_price) : unit_price

  const frontlineCasePrice =
    typeof frontline_case_price == 'string' ? parseFloat(frontline_case_price) : frontline_case_price

  let modifiedData = {
    id: id,
    lastKey: key,
    lastValue: value,
    flatDiscountValue: '',
    percentageDiscountValue: '',
    casePriceValue: '',
  }

  let percentageInitialCalculation
  if (!isNaN(value) || value !== '') {
    // Calculate each of them
    switch (key) {
      case 'flat_discount':
        if (value > originalCasePrice) {
          value = originalCasePrice
        }

        modifiedData.flatDiscountValue = value

        percentageInitialCalculation = modifiedData.flatDiscountValue
        modifiedData.percentageDiscountValue =
          percentageInitialCalculation > 0 ? (percentageInitialCalculation / frontlineCasePrice) * 100 : 0

        //Removed wetTax from falt discount
        modifiedData.casePriceValue = floorToTwoDecimals(
          (originalCasePrice / (1 + wetTax) - modifiedData.flatDiscountValue) * (1 + wetTax)
        )

        if (!sell_by_case) {
          modifiedData.unitPriceValue =
            modifiedData.casePriceValue > 0
              ? floorToTwoDecimals((modifiedData.casePriceValue / wholesale_unit_per_case) * (unitSurcharge + 1))
              : 0
        }

        break

      case 'percentage_discount':
        if (value > 100) {
          value = 100
        }

        modifiedData.percentageDiscountValue = value
        modifiedData.flatDiscountValue = floorToTwoDecimals((frontlineCasePrice * value) / 100)

        //Removed wetTax from percentage discount
        modifiedData.casePriceValue = floorToTwoDecimals(
          (originalCasePrice / (1 + wetTax) - modifiedData.flatDiscountValue) * (1 + wetTax)
        )

        if (!sell_by_case) {
          modifiedData.unitPriceValue =
            modifiedData.casePriceValue > 0
              ? floorToTwoDecimals((modifiedData.casePriceValue / wholesale_unit_per_case) * (unitSurcharge + 1))
              : 0
        }
        break

      case 'case_price':
        if (value > originalCasePrice) {
          value = originalCasePrice
        }

        modifiedData.casePriceValue = value

        //Calculate discount on original case price excluding wetTax
        modifiedData.flatDiscountValue = floorToTwoDecimals(
          case_price / (1 + wetTax) - modifiedData.casePriceValue / (1 + wetTax)
        )

        percentageInitialCalculation = floorToTwoDecimals(modifiedData.flatDiscountValue)
        modifiedData.percentageDiscountValue =
          percentageInitialCalculation > 0 ? (percentageInitialCalculation / frontlineCasePrice) * 100 : 0
        if (!sell_by_case) {
          modifiedData.unitPriceValue =
            modifiedData.casePriceValue > 0
              ? floorToTwoDecimals((modifiedData.casePriceValue / wholesale_unit_per_case) * (unitSurcharge + 1))
              : 0
        }
        break

      case 'unit_price':
        if (value > originalUnitPrice) {
          value = originalUnitPrice
        }

        modifiedData.unitPriceValue = value
        modifiedData.casePriceValue = floorToTwoDecimals(value * wholesale_unit_per_case)

        //Calculate discount on original case price excluding wetTax
        modifiedData.flatDiscountValue = floorToTwoDecimals(
          case_price / (1 + wetTax) - modifiedData.casePriceValue / (1 + wetTax)
        )

        percentageInitialCalculation = modifiedData.flatDiscountValue
        modifiedData.percentageDiscountValue =
          percentageInitialCalculation > 0 ? (percentageInitialCalculation / frontlineCasePrice) * 100 : 0
        break
    }

    // Don't allow minus
    if (modifiedData.flatDiscountValue < 0) {
      modifiedData.flatDiscountValue = 0
    }
    if (modifiedData.percentageDiscountValue < 0) {
      modifiedData.percentageDiscountValue = 0
    }
    if (modifiedData.casePriceValue < 0) {
      modifiedData.casePriceValue = 0
    }
    if (modifiedData.unitPriceValue < 0) {
      modifiedData.unitPriceValue = 0
    }

    // Always round them up (if they are not being edited)
    if (key != 'flat_discount') {
      modifiedData.flatDiscountValue = parseFloat(modifiedData.flatDiscountValue).toFixed(2)
    }
    if (key != 'percentage_discount') {
      modifiedData.percentageDiscountValue = parseFloat(modifiedData.percentageDiscountValue).toFixed(2)
    }
    if (key != 'case_price') {
      modifiedData.casePriceValue = parseFloat(modifiedData.casePriceValue).toFixed(2)
    }
    if (key != 'unit_price') {
      if (!sell_by_case) {
        modifiedData.unitPriceValue = parseFloat(modifiedData.unitPriceValue).toFixed(2)
      }
    }
  }

  return modifiedData
}
export const addToCart = (id) => {
  return (dispatch, getState) => {
    const state = getState()
    const productsFullInfo = getProductsFullInfo({ [id]: state.productsSupplier.list[id] }, state)
    const cartItem = buildSupplierCartItem(productsFullInfo[id], state.productsSupplier.userInput[id])

    dispatch(toggleLoading(true))

    return Promise.all([dispatch(addRemoteCartItems([cartItem]))])
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        dispatch(toggleLoading(false))
        dispatch(clearUserInput(id))
        dispatch(requestFromServer())
      })

    // Old Code
    // --------
    // const state = getState();
    // const activeCustomerID = (typeof(state.supplier.activeCustomer.id) != 'undefined') ? state.supplier.activeCustomer.id : 0;
    // const productsFullInfo = getProductsFullInfo({ [id]: state.productsSupplier.list[id] }, state);
    // let cartList = getDumbCartForMember(state.cartSupplier.list, activeCustomerID);
    //
    // const cartItem = buildSupplierCartItem(productsFullInfo[id], state.productsSupplier.userInput[id]);
    //
    // let newCartList = {
    //     [cartItem.cartID]: cartItem
    // };
    //
    // cartList = appendCartListWithBackOrder(cartList, newCartList);
    //
    // dispatch(updateCartList(cartList, activeCustomerID));
    // dispatch(clearUserInput(id));
  }
}

/* Added isCaseConversion param to handle unit to case conversion on supplier*/
export const addToCartIfCaseAndUnitZero = (id, isCaseConversion = false) => {
  return (dispatch, getState) => {
    const state = getState()
    const productsFullInfo = getProductsFullInfo({ [id]: state.productsSupplier.list[id] }, state)
    const cartItem = buildSupplierCartItem(productsFullInfo[id], state.productsSupplier.userInput[id])
    dispatch(toggleLoading(true))

    return Promise.all([dispatch(addRemoteCartItemsCaseAndUnit([cartItem], isCaseConversion))])
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        dispatch(toggleLoading(false))
        dispatch(clearUserInput(id))
        dispatch(requestFromServer())
      })
  }
}

export const addAllToOrder = () => {
  return (dispatch, getState) => {
    const state = getState()
    const newCartList = buildSupplierCartList(state.productsSupplier.list, state.productsSupplier.userInput)

    dispatch(toggleLoading(true))

    return Promise.all([dispatch(addRemoteCartItems(Object.values(newCartList)))])
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        dispatch(toggleLoading(false))
        dispatch(clearAllUserInput())
        dispatch(requestFromServer())
      })

    // Old Code
    // --------
    // const state = getState();
    // const activeCustomerID = (typeof(state.supplier.activeCustomer.id) != 'undefined') ? state.supplier.activeCustomer.id : 0;
    // let cartList = getDumbCartForMember(state.cartSupplier.list, activeCustomerID);
    //
    // const newCartList = buildSupplierCartList(state.productsSupplier.list, state.productsSupplier.userInput);
    // cartList = appendCartListWithBackOrder(cartList, newCartList);
    //
    // dispatch(updateCartList(cartList, activeCustomerID));
    // dispatch(clearAllUserInput());
  }
}
